var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-7.91831e-09 18.6777C-7.33422e-08 19.23 0.447715 19.6777 1 19.6777L10 19.6777C10.5523 19.6777 11 19.23 11 18.6777C11 18.1254 10.5523 17.6777 10 17.6777L2 17.6777L2 9.67773C2 9.12545 1.55229 8.67773 1 8.67773C0.447716 8.67773 3.10387e-07 9.12545 2.8711e-07 9.67773L-7.91831e-09 18.6777ZM19.6777 1.00006C19.6777 0.44778 19.23 6.48682e-05 18.6777 6.4592e-05L9.67767 6.50135e-05C9.12539 6.46531e-05 8.67767 0.44778 8.67767 1.00006C8.67767 1.55235 9.12539 2.00006 9.67767 2.00006H17.6777L17.6777 10.0001C17.6777 10.5523 18.1254 11.0001 18.6777 11.0001C19.23 11.0001 19.6777 10.5524 19.6777 10.0001L19.6777 1.00006ZM1.70711 19.3848L19.3848 1.70717L17.9706 0.292958L0.292893 17.9706L1.70711 19.3848Z",
    fill: "#CCF900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.cf129c14c756cc17ea6ea531166a440f.svg";
export { ForwardRef as ReactComponent };